var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, EventEmitter, OnDestroy, OnInit, } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { HubEvent, } from '../../../models/hub/hub.event';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { EventTimeService } from '../../../services/event.time.service';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { FormBuilder, Validators } from '@angular/forms';
import { VisitorCalendarStore } from '../../../stores/visitor.calendar.store';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { DateFieldComponent } from '../../../common/components/date.time.field/date.field.component';
import { CustomEventCommand } from '../../../commands/hub/custom.event.command';
import { EditorChoiceStore } from '../../../stores/hub.calendar.store';
import { getRouteUrl, routeConfigs, } from '../../../common/constants/route.config';
import { clone } from 'common/extensions/object/object.extensions';
var EventFilterComponent = /** @class */ (function (_super) {
    __extends(EventFilterComponent, _super);
    function EventFilterComponent(router, activatedRoute, visitorApiService, formBuilder, visitorCalendarStore, editorChoiceStore) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.visitorApiService = visitorApiService;
        _this.formBuilder = formBuilder;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.editorChoiceStore = editorChoiceStore;
        _this.from = null;
        _this.to = null;
        _this.selectedEvents = [];
        _this.isFilteringBySpecificDates = false;
        _this.selectedCustomEvent = new CustomEventCommand();
        _this.command = new VisitorCalendarActionCommand();
        _this.mode = 'topbar';
        _this.isHideEditorChoice = false;
        _this.onFilter = new EventEmitter();
        return _this;
    }
    EventFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, customEventBtnId = _a.customEventBtnId;
        this.hubName = hubName;
        this.setSelectedCustomEventBtn(customEventBtnId);
        this.dateFormGroup = this.formBuilder.group({
            from: [null, [Validators.required]],
            to: [null, [Validators.required]],
        });
        this.editorChoiceTextHandler();
        this.visitorCalendarStore.actionCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (!command)
                return;
            setTimeout(function () {
                _this.command = clone(command);
                if (command.queryCommand.dateFilterText) {
                    _this.eventDateAccordion.setFilter(command.queryCommand.dateFilterText.toUpperCase(), command.queryCommand.dateFilterText !== 'FILTER BY DATE');
                }
                if (command.queryCommand.customEventBtnText) {
                    _this.customEventAccordion.setFilter(command.queryCommand.customEventBtnText, true);
                    var customBtn = _this.customEvents.find(function (x) { return x.btnText === command.queryCommand.customEventBtnText; });
                    if (customBtn) {
                        _this.selectedCustomEvent = customBtn;
                    }
                }
                else {
                    _this.selectedCustomEvent = null;
                }
                if (command.queryCommand.choice) {
                    _this.customEventAccordion.setFilter(_this.editorChoiceText, true);
                }
            });
        });
    };
    EventFilterComponent.prototype.onDateFieldKeyPress = function ($event, type) {
        if ($event && $event.key === 'Enter') {
            type === 'from'
                ? this.fromDateField.onKeyPress($event)
                : this.toDateField.onKeyPress($event);
        }
    };
    EventFilterComponent.prototype.clearFilter = function () {
        this.eventDateAccordion && this.eventDateAccordion.clearFilter(null, false);
        this.customEventAccordion &&
            this.customEventAccordion.clearFilter(null, false);
    };
    EventFilterComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.mode === 'topbar') {
            window.addEventListener('click', function (target) {
                if (target &&
                    target.srcElement &&
                    (target.srcElement['className'].indexOf('md2-datepicker') >= 0 ||
                        target.srcElement['className'].indexOf('md2-calendar') >= 0 ||
                        target.srcElement['className'].indexOf('ng-tns') >= 0 ||
                        target.srcElement['className'].indexOf('selected') >= 0 ||
                        target.srcElement['className'].indexOf('value') >= 0)) {
                    return;
                }
                _this.closeAccordion();
            });
        }
    };
    EventFilterComponent.prototype.ngOnDestroy = function () {
        var _this = this;
        window.removeEventListener('click', function () {
            _this.closeAccordion();
        });
    };
    EventFilterComponent.prototype.filterEvents = function ($event, title) {
        if ($event) {
            $event.stopPropagation();
        }
        var queryParams = title || 'defaultTarget';
        if (title === 'showSpecificDates') {
            this.isFilteringBySpecificDates = true;
            this.command.queryCommand.dateFilterText = 'Specific Dates';
            return;
        }
        else if (title !== 'Specific Dates') {
            this.isFilteringBySpecificDates = false;
        }
        this.onFilter.emit();
        var filterText = queryParams;
        var lastMid = new Date(new Date().setHours(0, 0, 0, 0));
        var nextMid = new Date(new Date().setHours(24, 0, 0, 0));
        switch (queryParams) {
            case 'Today':
                this.from = lastMid;
                this.to = nextMid;
                this.fromForSelector = null;
                this.toForSelector = null;
                break;
            case 'Tomorrow':
                this.from = new Date(lastMid.setDate(lastMid.getDate() + 1));
                this.to = new Date(lastMid.setDate(nextMid.getDate() + 1));
                this.fromForSelector = null;
                this.toForSelector = null;
                break;
            case 'This Weekend':
                // from Friday to Sunday
                this.from = new Date(lastMid.setDate(lastMid.getDate() + (7 - lastMid.getDay() - 2)));
                this.to = new Date(nextMid.setDate(nextMid.getDate() + (7 - nextMid.getDay() + 1)));
                this.fromForSelector = null;
                this.toForSelector = null;
                break;
            case 'This Week':
                this.from = new Date(lastMid.setDate(lastMid.getDate() + (lastMid.getDay() - 2)));
                this.to = new Date(nextMid.setDate(nextMid.getDate() + (7 - nextMid.getDay())));
                this.fromForSelector = null;
                this.toForSelector = null;
                break;
            case 'Specific Dates':
                if (this.fromForSelector) {
                    this.from = this.fromForSelector;
                    this.from.setHours(0);
                    this.from.setMinutes(0);
                    this.from.setSeconds(0);
                    var timePrefix = this.toForSelector ? '' : 'After ';
                    filterText =
                        timePrefix + EventTimeService.toDayAndMonthFormat(this.from);
                }
                else {
                    this.from = null;
                    filterText = 'Before';
                }
                if (this.toForSelector) {
                    this.to = this.toForSelector;
                    this.to.setHours(23);
                    this.to.setMinutes(59);
                    this.to.setSeconds(59);
                    filterText += ' - ' + EventTimeService.toDayAndMonthFormat(this.to);
                }
                else {
                    this.to = null;
                }
                break;
            case 'allDates':
                this.from = null;
                this.to = null;
                this.fromForSelector = null;
                this.toForSelector = null;
                filterText = 'FILTER BY DATE';
            // this.gotoEventCalendar();
            // return;
            case 'defaultTarget':
                break;
            case 'search':
                break;
            default:
        }
        this.command.queryCommand.search = null;
        this.command.queryCommand.from = this.from || null;
        this.command.queryCommand.to = this.to || null;
        this.command.queryCommand.category = 'all'; //this.category || null;
        this.command.queryCommand.joinedEventsIds = null;
        this.command.queryCommand.feedId = null;
        this.command.queryCommand.dateFilterText = filterText;
        // if (!this.command.isEventCalendar) {
        //     command.queryCommand.from = null;
        //     command.queryCommand.to = null;
        // }
        this.visitorCalendarStore.actionCommand.next(this.command);
        // visitor.components.ts uses this to handle browser's back button event
        console.log('topbar filterEvents command', this.command);
        localStorage.setItem(localStorageKeys.eventQueryCommand, JSON.stringify(this.command));
        this.mode === 'topbar' && this.closeAccordion();
        this.eventDateAccordion.setFilter(filterText.toUpperCase(), queryParams !== 'allDates');
        // this.customEventAccordion && this.customEventAccordion.clearFilter(null, false);
        // topbar and sidebar need to load calendar if on create event view
        if (this.mode !== 'map') {
            this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventCalendar, {
                hubName: this.hubName,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
    };
    EventFilterComponent.prototype.getFeedEvent = function (custom) {
        console.log('custom', custom);
        this.onFilter.emit();
        this.command.queryCommand.choice = null;
        this.command.queryCommand.search = null;
        // this.command.queryCommand.from = this.from;
        // this.command.queryCommand.to = this.to;
        this.command.queryCommand.category = null;
        this.command.queryCommand.joinedEventsIds = null;
        this.command.queryCommand.isCustom =
            custom.sourceType === 'selected' ? true : null;
        this.command.queryCommand.selectedEvents =
            custom.sourceType === 'selected' ? custom.events : null;
        this.command.queryCommand.customEventBtnText = custom.btnText;
        this.command.queryCommand.feedId =
            custom.sourceType === 'feed' ? custom.feedId : null;
        this.command.isEventCalendar = true;
        console.log('topbar getFeedEvent command', this.command);
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.selectedCustomEvent = null;
        // visitor.components.ts uses this to handle browser's back button event
        localStorage.setItem(localStorageKeys.eventQueryCommand, JSON.stringify(this.command));
        this.customEventAccordion.setFilter(custom.btnText || 'EVENT CATEGORIES', custom.sourceType.toLowerCase() !== 'all');
        this.mode === 'topbar' && this.closeAccordion();
        if (this.mode !== 'map') {
            this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventCalendar, {
                hubName: this.hubName,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
    };
    EventFilterComponent.prototype.editChoice = function () {
        this.onFilter.emit();
        this.command.queryCommand.search = null;
        // command.queryCommand.from = null;
        // command.queryCommand.to = null;
        this.command.queryCommand.category = null;
        this.command.queryCommand.choice = true;
        this.command.queryCommand.isCustom = null;
        this.command.queryCommand.mostAttended = null;
        this.command.queryCommand.feedId = null;
        this.command.queryCommand.joinedEventsIds = null;
        this.command.queryCommand.selectedEvents = null;
        this.command.queryCommand.customEventBtnText = null;
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.selectedCustomEvent = null;
        // visitor.components.ts uses this to handle browser's back button event
        console.log('topbar editor choice command', this.command);
        localStorage.setItem(localStorageKeys.eventQueryCommand, JSON.stringify(this.command));
        this.customEventAccordion &&
            this.customEventAccordion.setFilter(this.editorChoiceText);
        // this.eventDateAccordion && this.eventDateAccordion.clearFilter(null, false);
        this.mode === 'topbar' && this.closeAccordion();
        if (this.mode !== 'map') {
            this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventCalendar, {
                hubName: this.hubName,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
    };
    EventFilterComponent.prototype.closeAccordion = function () {
        this.eventDateAccordion && this.eventDateAccordion.close();
        this.customEventAccordion && this.customEventAccordion.close();
    };
    EventFilterComponent.prototype.editorChoiceTextHandler = function () {
        var _this = this;
        this.editorChoiceStore.infoCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (editorChoice) {
            _this.editorChoiceText = editorChoice.editorChoiceForEvent;
        });
    };
    EventFilterComponent.prototype.setSelectedCustomEventBtn = function (customEventBtnId) {
        var _this = this;
        console.log('customEventBtnId in event filter', customEventBtnId);
        setTimeout(function () {
            if (customEventBtnId) {
                var customBtn = _this.customEvents.find(function (x) { return x._id.toString() === customEventBtnId; });
                if (customBtn) {
                    _this.selectedCustomEvent = customBtn;
                    _this.customEventAccordion.setFilter(customBtn.btnText);
                }
            }
        });
    };
    return EventFilterComponent;
}(BaseComponent));
export { EventFilterComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/event.filter/event.filter.component.ts.pre-build-optimizer.js